<template>
  <label class="ent-page-size">
    <span class="ent-page-size__label">{{ $t('entity.pagination.pageSize') }}</span>
    <select class="ent-page-size__select" :value="modelValue" @change="onChange($event)">
      <option v-for="size in options" :key="size" :value="size">{{ size }}</option>
    </select>
  </label>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

/**
 * Sélecteur du nombre de lignes par page, à placer dans le bloc `.ent-pagination`
 * à côté de `<jhi-item-count>` et `<b-pagination>`.
 */
export default defineComponent({
  name: 'page-size-select',
  props: {
    modelValue: { type: Number, required: true },
    options: { type: Array as () => number[], default: () => [10, 20, 50, 100] },
  },
  emits: ['update:modelValue'],
  methods: {
    onChange(event: Event): void {
      this.$emit('update:modelValue', Number((event.target as HTMLSelectElement).value));
    },
  },
});
</script>
